import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface CampaignUrlDialogData {
  campaignUrl: string;
  campaignName?: string;
}

@Component({
  selector: 'app-campaign-url-dialog',
  templateUrl: './campaign-url-dialog.component.html',
  styleUrls: ['./campaign-url-dialog.component.css'],
})
export class CampaignUrlDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<CampaignUrlDialogComponent>,
    private readonly snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: CampaignUrlDialogData
  ) {}

  async copyUrl(): Promise<void> {
    const url = String(this.data.campaignUrl || '').trim();
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      this.snackBar.open('Campaign URL copied', 'Close', { duration: 2500 });
    } catch (_error) {
      this.snackBar.open(url, 'Close', { duration: 8000 });
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
